const SITE = 'https://ivyooo.com'
const IMAGE = 'https://ivyooo.com/assets/images/ivyooo.png'

const pages = {
  HOME: {
    title: 'iVYOOO — Filipino streaming for films and learning',
    description: 'iVYOOO is a Filipino-owned streaming app for movies, series, concerts, live events, sports, and educational content. Watch trailers now. The mobile apps are coming soon.',
    path: '/',
  },
  DOWNLOADS: {
    title: 'iVYOOO — Coming soon',
    description: 'The iVYOOO apps for iOS and Android are coming soon. Watch film trailers on ivyooo.com while you wait.',
    path: '/',
  },
  'ABOUT US': {
    title: 'iVYOOO — About us',
    description: 'iVYOOO is a wholly Filipino-owned streaming platform for entertainment and e-learning, built for audiences in the Philippines and abroad.',
    path: '/',
  },
}

function setMeta(name, content, attribute = 'name') {
  let el = document.head.querySelector(`meta[${attribute}="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attribute, name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

export function applySeo(route = 'HOME') {
  if (typeof document === 'undefined') return
  const page = pages[route] || pages.HOME
  const url = `${SITE}${page.path}`
  document.title = page.title
  setMeta('description', page.description)
  setMeta('robots', 'index,follow')
  setCanonical(url)
  setMeta('og:type', 'website', 'property')
  setMeta('og:site_name', 'iVYOOO', 'property')
  setMeta('og:title', page.title, 'property')
  setMeta('og:description', page.description, 'property')
  setMeta('og:url', url, 'property')
  setMeta('og:image', IMAGE, 'property')
  setMeta('twitter:card', 'summary_large_image')
  setMeta('twitter:title', page.title)
  setMeta('twitter:description', page.description)
  setMeta('twitter:image', IMAGE)
}

export const defaultSeo = pages.HOME
